import React, { useEffect } from "react";
import { Button, Col, Form, Input, Row } from "antd";
import { CounterListProps } from "../../../../types/interfaces";
import { useForm } from "antd/es/form/Form";

interface Props {
  values: CounterListProps;
  onFinish: (values: CounterListProps) => void;
  onEdit: boolean;
}

export const InputCounterForm = ({ values, onFinish, onEdit }: Props) => {
  const [form] = useForm();
  useEffect(() => {
    form.setFieldsValue(values);
  }, [form, values]);

  return (
    <>
      <Row gutter={16} justify="center">
        <Col xs={24} md={16}>
          <Form
            layout="vertical"
            initialValues={values}
            form={form}
            onFinish={onFinish}
          >
            <Form.Item
              label="Identifier"
              name="description"
              rules={[{ required: true, message: "Identifier" }]}
            >
              <Input
                name="description"
                placeholder="Identifier"
                value={values.description}
              />
            </Form.Item>
            <Form.Item style={{ textAlign: "center" }}>
              <Button type="primary" htmlType="submit" style={{ width: "50%" }}>
                {onEdit ? "Edit" : "Create"}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </>
  );
};
